import { MAX_USERGROUPNAME_LENGTH } from '../utils/constants';
import PropTypes from 'prop-types';
import { globalStyles as styles } from '../../core/style/gstheme';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import Paging from '../../core/Paging';
import PagingFilter from '../../core/PagingFilter';
import GS from '../../grafsync/grafsync';
import Errored from '../Errored';
import Loading from '../Loading';
import { makeCancelable } from '../utils/utils';
import GroupCard from './GroupCard';

class GroupStructure extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      groups: [],
      text: "",
      page: 1,
      refreshAt: null,
      pageSize: 8,
      noneFound: false,
      noResults: true,
      pageCount: null,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    this.handlePageChange();
  }

  handleFilterChange = (text) => {
    this.props.onUpdate();
    this.setState({ text: text.trim(), page: 1 }, () => this.handlePageChange(this.state.page));
  };

  handlePageChange = async (page = 1) => {
    this.setState(
      { isLoading: true },
      () => {
        const payload = {
          search: [{
            predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
            value: "https://graphifi.com/schema/accesscontrol/UserGroup"
          }, {
            predicate: "http://www.w3.org/2000/01/rdf-schema#label",
            value: this.state.text,
            isExactMatch: false
          }],
          graph: [GS.getActiveSubscription()],
          page: page,
          pageSize: this.state.pageSize,
          sort: ["http://www.w3.org/2000/01/rdf-schema#label"]
        };
        if (this.props.deletedGroups && this.props.deletedGroups.length > 0) payload.exclude = this.props.deletedGroups;
        this.doSearch(payload)
          .promise
          .then(data => {
            if (data.results && data.results.length > 0) {
              const sortedGroups = this.sortGroups(data.results);
              const groupIDs = sortedGroups ? sortedGroups.map(result => result.id) : null;
              this.setState({ groups: groupIDs, isLoadingGroups: false });
              this.loadData(groupIDs)
                .promise
                .then(() => this.setState({
                  groups: groupIDs,
                  page,
                  noResults: false,
                  noneFound: false,
                  pageCount: data.pageCount,
                  isLoading: false
                }))
                .catch((e) => {
                  if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
                });
            }
            else {
              this.setState({
                isLoading: false,
                page: 1,
                noneFound: true,
                noResults: false
              });
            }
          })
          .catch((e) => {
            if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
          });
      });
  };

  static getDerivedStateFromProps(props, state) {
    if (!state.isLoading && props.refreshAt !== state.refreshAt && props.refreshAt !== null) {
      return {
        groups: null,
        noResults: true,
        refreshAt: props.refreshAt
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (!this.state.isLoading && this.state.groups === null && this.state.noResults === true) {
      this.handlePageChange(this.state.page);
    }
  }

  doSearch(payload) {
    this.cancellable = makeCancelable(
      GS.search(payload)
    );
    return this.cancellable;
  }

  loadData(iris, options) {
    this.cancellable = makeCancelable(
      GS.loadData(iris, options, GS.getActiveSubscription(), false)
    );
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  sortGroups(groups) {
    return groups.sort(function (a, b) {
      let orderA = a.label.en.toLowerCase();
      let orderB = b.label.en.toLowerCase();
      if (orderA < orderB) return -1;
      if (orderA > orderB) return 1;
      return 0;
    });
  }

  render() {

    const { isLoading, groups, page, pageCount, isErrored, noneFound, text } = this.state;
    const { onSelectGroup, classes, altered, selectedGroup } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;

    return (
      <div
        className={classes.controlPanel}>
        <div style={{ marginTop: '10px' }}>
          <PagingFilter
            handleFilterChange={this.handleFilterChange}
            placeholder="Enter part of a group name"
            text={text}
            maxLength={MAX_USERGROUPNAME_LENGTH}
            altered={altered} />
          <Paging page={page} pageCount={pageCount} handlePageChange={this.handlePageChange} />
        </div>
        <div data-test="groups-list" className={classes.tree} style={pageCount > 1 ? { top: '190px', paddingTop: '5px' } : { top: '154px', paddingTop: '5px' }}>
          {noneFound || !groups ?
            <ActionText format="result">No results.</ActionText>
            :
            groups.map((group) => <GroupCard
              isSelected={selectedGroup === group}
              key={group}
              graph={GS.getActiveSubscription()}
              id={group}
              onSelectGroup={onSelectGroup} />)
          }
        </div>
      </div>
    );
  }

}

GroupStructure.defaultProps = {
  altered: false
};

GroupStructure.propTypes = {
  classes: PropTypes.object,
  altered: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  selectedGroup: PropTypes.string,
  deletedGroups: PropTypes.arrayOf(PropTypes.string),
  onSelectGroup: PropTypes.func.isRequired
};

export default withStyles(styles)(GroupStructure);